import styled, { css } from 'styled-components';
import { Colors } from 'styles/constants';

export const BasePanelStyle = css`
  display: flex;
  border-radius: 6px;
  background: ${Colors.White};
`;

export const BasePanel = styled.div`
  ${BasePanelStyle};
`;

export const Ghost = styled.div`
  width: 20px;
  height: 20px;
  display: block;
`;